import {createEntityAdapter, Dictionary, EntityAdapter, EntityState} from '@ngrx/entity';
import {ActionReducer, createReducer, on} from '@ngrx/store';
import {createFeature, createSelector} from '@ngrx/store';
import {VisitPlanJobModel} from "../../../models/visit-plan-job.model";
import {VisitPlanJobActions, VisitPlanJobAPiActions} from "./visit-plan-job.actions";

export interface VisitPlanJobState extends EntityState<VisitPlanJobModel> {
  cursor: string;
  isLoading: boolean;
}

const adapter: EntityAdapter<VisitPlanJobModel> = createEntityAdapter<VisitPlanJobModel>();

const initialState: VisitPlanJobState = adapter.getInitialState({
  cursor: null,
  isLoading: false
});

const reducer: ActionReducer<VisitPlanJobState> = createReducer(
  initialState,

  on(VisitPlanJobAPiActions.getVisitPlanJobs, (state) => ({...state, isLoading: true})),

  on(VisitPlanJobAPiActions.getVisitPlanJobsSuccess, (state, {visitPlanJobs, cursor}) => {
    return adapter.setMany(visitPlanJobs,
      {
        ...state,
        cursor: cursor,
        isLoading: false
      })
  }),

  on(VisitPlanJobActions.removeAll, (state) => adapter.removeAll(state)),

  on(VisitPlanJobActions.clearStore, () => ({...initialState}))

);

export const visitPlanJobFeature = createFeature({
  name: 'VisitPlanJob',
  reducer,
  extraSelectors: ({
                     selectVisitPlanJobState,
                     selectEntities,
                     selectCursor,
                     selectIsLoading
                   }) => ({
    ...adapter.getSelectors(selectVisitPlanJobState),
    selectVisitPlanJobs: () => createSelector(
      selectEntities,
      (entities: Dictionary<VisitPlanJobModel>) => Object.values(entities),
    ),
    selectCursor: () => createSelector(
      selectCursor,
      (cursor) => cursor
    ),
    selectIsLoading: () => createSelector(
      selectIsLoading,
      (isLoading) => isLoading
    )
  })
});

